import { useState, useCallback, useContext } from "react";
import {
  BASIC_AUTH_TOKKEN,
  LOGIN_ID,
  SESSION_ID,
  USER_NAME,
} from "../constants/LocalStorageKeyValuePairString";
import { getFromLocalStorage } from "../utils/localStorageUtils";
import { generateRequestId } from "../utils/RequestIdGenerator";
import { axiosInstance } from "../services/AxiosIntercepter";
import { ApiType } from "../services/ApiTags";
import { AuthContext } from "../context/AuthContext";

const UseAxiosV1Api = () => {
  const [dataV1, setData] = useState(null);
  const [errorV1, setError] = useState(null);
  const [showProgressBarV1, setProgressBar] = useState(false);
  const { authDetails } = useContext(AuthContext);


  const fetchDataV1 = useCallback(
    async (
      url,
      apiType,
      method = ApiType.POST_METHOD,
      encryptedData = null,
      options = {},
      callback
    ) => {
      // show progress bar
      setProgressBar(true);

      let requestData = {};
      if (apiType === ApiType.BASIC_AUTH) {
        
      } else if (apiType === ApiType.SIGN_IN) {
        // set login request content
        requestData = {
          requestId: generateRequestId(),
          loginId: getFromLocalStorage(LOGIN_ID),
          basicAuthToken: getFromLocalStorage(BASIC_AUTH_TOKKEN),
          contentData: encryptedData,
        };
      } else if (apiType === ApiType.FORGOT_PASSWORD ||apiType === ApiType.RESET_PASSWORD) {
        // set login request content
        requestData = {
          requestId: generateRequestId(),
          loginId: getFromLocalStorage(LOGIN_ID),
          basicAuthToken: getFromLocalStorage(BASIC_AUTH_TOKKEN),
          contentData: encryptedData,
        };
      } else {
        // set common request content
        requestData = {
          requestId: generateRequestId(),
          loginId:getFromLocalStorage(LOGIN_ID),
          sessionId:getFromLocalStorage(SESSION_ID),
          contentData: encryptedData,
          loginUserName:getFromLocalStorage(USER_NAME)
        };
      }

      try {
        const response = await axiosInstance({
          url,
          method,
          data: requestData,
          ...options,
        });
        setData(response.data);
        if (callback) {
          callback(response.data);
        }
      } catch (error) {
        // show error
        setError(error);
      } finally {
        // hide progress bar
        setProgressBar(false);
      }
    },
    []
  );

  return { dataV1, errorV1, showProgressBarV1, fetchDataV1 };
};

export default UseAxiosV1Api;
